import JobsState from './jobs-state';
import Action from '../../state/action';

const jobsReducer = (state: JobsState, action: Action): JobsState => {
  switch (action.type) {
    case 'update-jobs': {
      const { fetched, filtered, sorted, page } = action;
      return {
        ...state,
        fetched,
        filtered,
        sorted,
        page,
      };
    }
    default:
      return state;
  }
};

export default jobsReducer;
